<div class="large-chart-view-container">
  <div class="chart-header">
    <div class="chart-title-wrapper">
      <button class="btn-back" (click)="onClose()" [matTooltip]="'Back'" matTooltipPosition="below">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h2 class="chart-title">{{ chartData?.title || 'Chart' }}</h2>
      <span class="duration-badge" *ngIf="getDurationBehaviorLabel()" [ngClass]="getDurationBehaviorClass()">
        {{ getDurationBehaviorLabel() }}
      </span>
    </div>
    <div class="chart-actions">
      <button
        class="btn-action"
        (click)="onDownload()"
        [disabled]="isLoading"
        [matTooltip]="'Export Data'"
        matTooltipPosition="below">
        <img src="assets/icons/file_download.svg" alt="download" [class.spinning]="isLoading" />
      </button>
    </div>
  </div>

  <div class="chart-content">
    <div *ngIf="isLoading" class="chart-loading">
      <div class="loading-spinner"></div>
      <p>Loading chart data...</p>
    </div>
    <div *ngIf="hasError && !isLoading" class="chart-error">
      <p class="error-message">{{ errorMessage || 'Failed to load chart data' }}</p>
    </div>
    <highcharts-chart
      *ngIf="!hasError && !isLoading && chartOptions"
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      (chartInstance)="chartRef = $event"
      style="width: 100%; height: 100%; display: block;"
    ></highcharts-chart>
    <div *ngIf="!hasError && !isLoading && !chartOptions" class="chart-empty">
      <div class="no-data-container">
        <div class="no-data-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 11H7V13H9V11Z" fill="currentColor" opacity="0.3"/>
            <path d="M13 11H11V13H13V11Z" fill="currentColor" opacity="0.3"/>
            <path d="M17 11H15V13H17V11Z" fill="currentColor" opacity="0.3"/>
            <path d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z" fill="currentColor"/>
          </svg>
        </div>
        <p class="no-data-message">No data found</p>
        <p class="no-data-subtitle">There is no data available to display for this chart</p>
      </div>
    </div>
  </div>

  <div class="chart-table-section" *ngIf="hasTableData()">
    <div class="table-header">
      <h3 class="table-title">Data Table</h3>
    </div>
    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th *ngFor="let column of getTableColumns()">{{ formatColumnName(column) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getTableData(); trackBy: trackByIndex">
            <td *ngFor="let column of getTableColumns()">{{ formatCellValue(row[column], column) }}</td>
          </tr>
          <tr class="total-row" *ngIf="getTotalRow()">
            <td *ngFor="let column of getTableColumns()" class="total-cell">
              <strong>{{ formatCellValue(getTotalRow()[column], column) }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="chart-footer">
    <div class="footer-content">
      <div class="footer-row">
        <div class="timestamp-info">
          <span class="timestamp-label">Last updated:</span>
          <span class="timestamp-value">{{ getLastUpdatedTime() }}</span>
        </div>
      </div>
      <div class="footer-row" *ngIf="getLastEditedTime() || getLastEditedBy()">
        <div class="timestamp-info">
          <span class="timestamp-label">Last edited:</span>
          <span class="timestamp-value">
            <ng-container *ngIf="getLastEditedTime()">{{ getLastEditedTime() }}</ng-container>
            <ng-container *ngIf="getLastEditedBy()">
              <span *ngIf="getLastEditedTime()"> by </span>{{ getLastEditedBy() }}
            </ng-container>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

